import React from 'react'
import MaskedInput from 'react-text-mask'
export const IsbnField = ({ inputRef, ...rest }) => {
  return (
    <MaskedInput
      {...rest}
      mask={[
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/
      ]}
      placeholderChar={'\u2000'}
    />
  )
}

export default IsbnField



// WEBPACK FOOTER //
// ./src/components/Fields/IsbnField.js